
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/relative-value",
      function () {
        return require("private-next-pages/tools/relative-value/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/relative-value"])
      });
    }
  